import React from 'react'
import PropTypes from 'prop-types'
import { useActionButton } from './ActionButton.hooks'

const ActionButton = props => {
	const [
		{ key, Element, className, children, href, editable, rounded, rest, action },
		{ handleClick, handleChange },
	] = useActionButton(props)

	return (
		Element && (
			<Element
				key={key}
				action={action}
				{...rest}
				className={className}
				href={href}
				onClick={handleClick}
				editable={editable}
				onChange={handleChange}
				rounded={rounded}
			>
				{children}
			</Element>
		)
	)
}

ActionButton.propTypes = {
	className: PropTypes.string,
	action: PropTypes.string,
	children: PropTypes.string,
	href: PropTypes.string,
	onClick: PropTypes.func,
	onChange: PropTypes.func,
	editable: PropTypes.bool,
	rounded: PropTypes.bool,
	variant: PropTypes.oneOf(['filled', 'outlined']),
	color: PropTypes.oneOf(['white', 'primary', 'secondary', 'text']),
	primaryColor: PropTypes.string,
}

export default ActionButton
